












































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import DetailedConfirmModal from '@/components/prine/DetailedConfirmModal.vue';
import type { Trade } from '@/models/trade';
import type { User } from '@/models/user';
import { tradeWebservice } from '@/webservices/trade';
import PrineButton from '@/components/prine/PrineButton.vue';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'StoreUpdateTrade',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        DetailedConfirmModal,
        PrineButton,
    },
})
export default class StoreUpdateTrade extends Vue {
    public FormState = FormState;

    // Data
    protected disabled: boolean = false;
    protected errorMsg: string = '';
    protected isConfirmModalActive: boolean = false;
    protected state: FormState = FormState.New;

    protected trade: Trade = {} as Trade;

    protected loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    protected affectedData: Map<string, number> = new Map();

    @Getter('account/userInfo') private userInfo: User;

    // Mounted is called initially
    private mounted() {
        if (this.$route.query.hasOwnProperty('tradeId')) {
            this.load(this.$route.query.tradeId.toString());
            this.state = FormState.Update;
        }
    }

    private load(tradeId: string) {
        this.loading.data = true;
        tradeWebservice.getById(tradeId).then((response) => {
            this.trade = response.data;
            this.loading.data = false;
            this.affectedData.set(this.$tc('keywords.lesson', 2).toString(), this.trade.lessons_count);
            this.affectedData.set(this.$tc('keywords.worksheets', 2).toString(), this.trade.worksheets_count);
        });
    }

    private save() {
        this.disabled = true;
        const self = this;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            tradeWebservice
                .store(this.trade)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.store.trade').toString(),
                        type: 'is-success',
                    });
                    this.$router.push({ path: '/knowledge/combined' });
                    this.$emit('syncKnowledge');
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        } else if (this.state === FormState.Update) {
            tradeWebservice
                .update(this.trade)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.update.trade').toString(),
                        type: 'is-success',
                    });
                    this.$router.push({ path: '/knowledge/combined' });
                    this.$emit('syncKnowledge');
                    this.disabled = false;
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private toggleConfirmModal(answer) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (answer) {
            this.remove();
        }
    }

    private remove() {
        const self = this;
        tradeWebservice
            .remove(this.trade)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.delete.trade').toString(),
                    type: 'is-success',
                });
                this.$router.push({ path: '/knowledge/combined' });
                this.$emit('syncKnowledge');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private validate() {
        if (!this.trade.title || this.trade.title === '') {
            this.errorMsg = 'title';
            return 0;
        } else if (!this.trade.bkp) {
            this.errorMsg = 'bkp';
            return 0;
        } else {
            return true;
        }
    }
}
